import comp from "./AITutorVideoModalityV2";
export default comp;
